import { makeActionCreator } from '../../../modules/utilities/store'
import CHAT_MANAGEMENT_EXPERIENCE_TYPES from '../../types/experiences/ChatManagement'
import ChatManagementMessageListSlice from '../../slices/experiences/ChatManagementMessageListSlice'
import ChatManagementChatGroupListSlice from '../../slices/experiences/ChatManagementChatGroupListSlice'

const ChatManagementExperienceActions = {
  messageList: ChatManagementMessageListSlice.actions,
  chatGroupList: ChatManagementChatGroupListSlice.actions,
  /**
   * @param messageItem {StoreMessage}: StoreMessage instance containing created message data.
   * @param onSuccess {function}: executed if creation was successful.
   * @returns {{ type: string, data: { messageItem: StoreMessage, onSuccess: function } }}
   */
  create: makeActionCreator(CHAT_MANAGEMENT_EXPERIENCE_TYPES.CREATE_MESSAGE, 'messageItem', 'onSuccess'),
  /**
   * @param messageCategoryItem {StoreMessageCategory}: StoreMessageCategory instance containing edited message category
   * data.
   * @param onSuccess {function}: executed if editing was successful.
   * @returns {{ type: string, data: { messageCategoryItem: StoreMessageCategory, onSuccess: function } }}
   */
  editMessageCategory: makeActionCreator(
    CHAT_MANAGEMENT_EXPERIENCE_TYPES.EDIT_MESSAGE_CATEGORY,
    'messageCategoryItem',
    'onSuccess'
  ),
  /**
   * Fetch messages for a chat group (uses chatGroupMessages::get / chatGroupMessages::get::response).
   */
  fetchChatGroupMessages: makeActionCreator(
    CHAT_MANAGEMENT_EXPERIENCE_TYPES.FETCH_CHAT_GROUP_MESSAGES,
    'chatGroupId',
    'deviceUuid',
    'limit',
    'page',
    'sort'
  ),
  /**
   * @param chatGroupItem {StoreChatGroup}: StoreChatGroup instance containing edited chat group data.
   * @param onSuccess {function}: executed if creation was successful.
   * @returns {{ type: string, data: { chatGroupItem: StoreChatGroup, onSuccess: function } }}
   */
  createChatGroup: makeActionCreator(CHAT_MANAGEMENT_EXPERIENCE_TYPES.CREATE_CHAT_GROUP, 'chatGroupItem', 'onSuccess'),
  /**
   * @param chatGroupItem {StoreChatGroup}: StoreChatGroup instance containing edited chat group data.
   * @param onSuccess {function}: executed if editing was successful.
   * @returns {{ type: string, data: { chatGroupItem: StoreChatGroup, onSuccess: function } }}
   */
  editChatGroup: makeActionCreator(CHAT_MANAGEMENT_EXPERIENCE_TYPES.EDIT_CHAT_GROUP, 'chatGroupItem', 'onSuccess'),
  /**
   * @param chatGroupId {string}: id of chatGroup to delete.
   * @returns {{ type: string, data: { chatGroupId: string } }}
   */
  deleteChatGroup: makeActionCreator(CHAT_MANAGEMENT_EXPERIENCE_TYPES.DELETE_CHAT_GROUP, 'chatGroupId'),
  patchChatGroupPhoto: makeActionCreator(
    CHAT_MANAGEMENT_EXPERIENCE_TYPES.PATCH_CHAT_GROUP_PHOTO,
    'chatGroupId',
    'photoId'
  ),
  /**
   * Toggle agent user or tracker membership for a chat group.
   * memberKind: 'agent' | 'tracker'
   */
  updateChatGroupMemberAssignation: makeActionCreator(
    CHAT_MANAGEMENT_EXPERIENCE_TYPES.UPDATE_CHAT_GROUP_MEMBER_ASSIGNATION,
    'chatGroupId',
    'memberKind',
    'memberKey',
    'assigned'
  ),
  updateChatGroupMembers: makeActionCreator(
    CHAT_MANAGEMENT_EXPERIENCE_TYPES.UPDATE_CHAT_GROUP_MEMBERS,
    'chatGroupId',
    'userIds',
    'deviceIds'
  ),
  /**
   * Subscribe to a chat context over sockets.
   */
  subscribeContext: makeActionCreator(
    CHAT_MANAGEMENT_EXPERIENCE_TYPES.SUBSCRIBE_CONTEXT,
    'chatGroupId',
    'userId',
    'deviceId'
  ),
  /**
   * Unsubscribe from a chat context over sockets.
   */
  unsubscribeContext: makeActionCreator(
    CHAT_MANAGEMENT_EXPERIENCE_TYPES.UNSUBSCRIBE_CONTEXT,
    'chatGroupId',
    'userId',
    'deviceId'
  ),
  /** Reload chat groups (unread counts) and recent messages for header badge. */
  refreshUnreadSources: makeActionCreator(CHAT_MANAGEMENT_EXPERIENCE_TYPES.REFRESH_UNREAD_SOURCES),
  /** Mark the currently subscribed device/user/group thread read (legacy chat click/focus). */
  markActiveThreadRead: makeActionCreator(CHAT_MANAGEMENT_EXPERIENCE_TYPES.MARK_ACTIVE_THREAD_READ)
}

export default ChatManagementExperienceActions
